export default "__VITE_ASSET__DAwW8F0x__"